<div class="mask-editor-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">
      <mat-icon>crop</mat-icon>
      {{'viewer.image.mask_editor' | translate}}
    </h2>

    <span class="spacer"></span>

    <lib-button (click)="cancel()" icon="close" color="none" textColor="muted" tooltip="{{'form.close'|translate}}">
    </lib-button>
  </div>

  <div class="toolbar">
    <mat-button-toggle-group [value]="mode()" (change)="setMode($event.value)" aria-label="Mask action">
      <mat-button-toggle value="delete">
        <mat-icon>backspace</mat-icon>
        {{'viewer.image.mask_delete' | translate}}
      </mat-button-toggle>

      <mat-button-toggle value="keep">
        <div class="btn-toggle">
          <mat-icon>crop_free</mat-icon>
          {{'viewer.image.mask_keep' | translate}}
        </div>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <span class="spacer"></span>

    <lib-button (click)="undo()" icon="undo" color="outline" [disabled]="!canUndo()"
      tooltip="{{'form.cancel'|translate}}">
    </lib-button>

    <lib-button (click)="reset()" icon="restart_alt" color="outline" text="{{'viewer.image.mask_reset'|translate}}">
    </lib-button>
  </div>

  <div class="canvas-container">
    <div #maskEditorContainer class="mask-container">
      @if (isLoading()) {
      <p class="info-text">{{'viewer.image.mask_loading' | translate}}</p>
      }
    </div>
  </div>

  <!-- <div class="action-buttons">
    <lib-button (click)="cancel()" icon="close" color="outline" text="{{'form.cancel' | translate}}">
    </lib-button>

    <lib-button (click)="apply()" icon="save" color="primary" text="{{'datepicker.applyLabel' | translate}}">
    </lib-button>
  </div> -->
</div>